module.exports = __webpack_public_path__ + "static/img/auth_success.2b1a4e01.png";